export default __webpack_public_path__ + "abf11ad224609224d1317f581dd175bd.png";